import { Fragment, useEffect, useState } from 'react'
import { Visible, Hidden } from '@leroy-merlin-br/backyard-react'

import { OptionFilterItem } from '..'

import * as S from './styled'

const INITIAL_VISIBLE_OPTIONS = 4
const PADDING_RIGHT_WITHOUT_SCROLL = 21
const PADDING_RIGHT_WITH_SCROLL = 8

type Option = {
  label: string
  count?: number
  isRefined: boolean
  value: string
}

type Props = {
  numberOptions?: number
  options: Array<Option>
  refine: (value: string, index: number) => void
}

const FilterOptions = ({
  numberOptions = INITIAL_VISIBLE_OPTIONS,
  options = [],
  refine
}: Props) => {
  const itemSpacing =
    options.length <= numberOptions
      ? PADDING_RIGHT_WITHOUT_SCROLL
      : PADDING_RIGHT_WITH_SCROLL

  const renderOptionFilter = (
    option: Option,
    isMobile = false,
    index: number
  ) => {
    const { label, count, isRefined, value } = option
    const keyName = isMobile ? 'mobile' : 'desktop'
    return (
      <OptionFilterItem
        key={`${keyName}${index}`}
        optionLabel={label}
        quantity={count}
        selected={isRefined}
        onFilterClick={() => refine(value, index)}
        rightSpacing={!isMobile ? itemSpacing : 0}
      />
    )
  }

  return (
    <Fragment>
      <Visible when={['giga', 'tera']}>
        <S.Content fixedHeight={itemSpacing === PADDING_RIGHT_WITH_SCROLL}>
          {options.map((option, index) =>
            renderOptionFilter(option, false, index)
          )}
        </S.Content>
      </Visible>

      <Hidden when={['giga', 'tera']}>
        <S.Content>
          {options.map((option, index) =>
            renderOptionFilter(option, true, index)
          )}
        </S.Content>
      </Hidden>
    </Fragment>
  )
}

export default FilterOptions
